import { branch } from '../constants'

module.exports = (transaction) ->
  toDestroy = await new Weaver.Query(undefined, branch).restrict(['NodeSizeParams', 'RelationSizeParams', 'nodeSizeParams', 'relationSizeParams']).useTransaction(transaction).find()
  Weaver.Node.batchDestroy(toDestroy, { transaction, branch })
